
<div
	class="media-preset-container"
	:selected="selected"
	:tabindex="tabindex"
	@click="handleClick($event)"
>
	<div class="media-preset-header">
		<slot name="header" />
	</div>
	<div class="media-preset-content">
		<slot />
	</div>
</div>
